import {Component, OnInit} from '@angular/core';
import {FoldersService} from '../../../../../core/ek-e-commerce/ek-services/folders.service';
import {CountFolderState} from '../../../../../core/ek-e-commerce/ek-models/count-statistics.model';
import {BehaviorSubject} from 'rxjs';
import {ClientsListPopUpComponent} from '../folders/clients-list-pop-up/clients-list-pop-up.component';
import {MatDialog} from '@angular/material/dialog';
import {MenuConfigService} from '../../../../../core/_base/layout';
import { FOLDER_STATES } from '../../Shared/Constants/folderStates';

export interface FolderSummary {
    folderState: string;
    totalCount: number;
    total: number | string; // to accommodate "NaN" as string
}
@Component({
    selector: 'kt-order-statistics',
    templateUrl: './order-statistics.component.html',
    styleUrls: ['./order-statistics.component.scss']
})
export class OrderStatisticsComponent implements OnInit {


    statisticsSubject$ = new BehaviorSubject<FolderSummary[]>(null);
    countStatistics$ = this.statisticsSubject$.asObservable();

    diameter = 200;
    foldersSubject$: BehaviorSubject<CountFolderState[]> = new BehaviorSubject<CountFolderState[]>([]);
    currentRole = '';

    constructor(private folderService: FoldersService, public dialog: MatDialog, private menuConfigService: MenuConfigService) {
        this.currentRole = JSON.parse(localStorage.getItem('currentUser')).roles;
    }

    ngOnInit(): void {

        this.menuConfigService.statisticsSubject$.subscribe((data) => {
            this.foldersSubject$.next(data);
        });


        this.folderService.FoldersStatisticsWithTotal().subscribe({
            next: (res) => {
                if (res.length > 0) {
                    // sort status
                    this.statisticsSubject$.next(this.sortFolderDataByOrder(res));
                }
            }
        });

    }

    sortFolderDataByOrder(
        data: FolderSummary[],
    ): FolderSummary[] {
        const orderMap = new Map<string, number>(
            FOLDER_STATES.map(state => [state.value, state.order])
        );

        return [...data].sort((a, b) => {
            const orderA = orderMap.get(a.folderState) ?? Infinity;
            const orderB = orderMap.get(b.folderState) ?? Infinity;
            return orderA - orderB;
        });
    }

    openClientPopUp() {
        this.dialog.open(ClientsListPopUpComponent, {
            width: '92rem',
        });
    }

}
